/*
* 车辆档案之OBD故障组件
* 描述：对应车辆的OBD故障列表，包括查询功能
* 创建时间：2017-03-31
* 创建人：zhanlz
* 修改时间：
*/
<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单部分开始-->
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">设备ID</label>
				<div class="col-sm-3">
					<input class="form-control" v-model.trim="queryParam.deviceId" maxlength="10">
				</div>
				<label class="col-sm-1 control-label">设备编号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="queryParam.deviceNum" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">故障码</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="queryParam.obdErrorCode" maxlength="20">
				</div>

			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">故障开始时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker class="form-control" v-model="queryParam.obdErrorDateBegin" ref="dateFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">故障结束时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker class="form-control" v-model="queryParam.obdErrorDateEnd" ref="dateTo"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label ">状态</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="queryParam.status">
						<option v-for="(option, index) in statuslist"  v-bind:value="option.udccode" v-bind:key="index + 'status'">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('carFileList_errorReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button v-if="permission.indexOf('carFileList_errorSelect') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
				</div>
			</div>
		</div>
		<!--表单部分结束-->
		<!--列表部分开始-->
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-hover">
				<thead>
					<tr role="row">
						<th>设备ID</th>
						<th>设备编号</th>
						<th>故障码</th>
						<th>故障描述</th>
						<th>故障时间</th>
						<th>状态</th>
					</tr>
				</thead>
				<transition-group name="list-complete" tag="tbody">
					<tr v-for="(info,index) in infoList" v-bind:key="index + 'detailOBD'" class="list-complete-item">
						<td>{{info.deviceId}}</td>
						<td>{{info.deviceNum}}</td>
						<td>{{info.obdErrorCode}}</td>
						<td>{{info.content}}</td>
						<td>{{info.obdErrorDate}}</td>
						<td>{{info.status}}</td>
					</tr>
				</transition-group>

			</table>
		</div>
		<!--列表部分结束-->
		<!--分页组件开始-->
		<pagination
			v-if="infoList.length>0"
			:pageInfo="pageInfo"
			v-on:getData="getPageNo"
			>
		</pagination>
		<!--分页组件结束-->
	</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { OPERATE_EXCEPTION } from 'static/message'
	import {DICTIONARY_MAP} from 'static/constant'
	import {getDictionaryFromArray} from 'util/util'

	export default {
	  name: 'DetailOwner',
	  components: {
	    Pagination,
	    Datepicker
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['carFileList'] ? this.$store.state.permission.permission['carFileList'] : [],
	      loadingstatus: false,
	      vehicleInfo: {},
	      infoList: [],							// 从接口获取的表格数据
	      statuslist: [],
	      pageInfo: {},							// 传给分页组件的属性对象
	      pageNo: 1,								// 从分页组件获取的当前页码数
				// 以下为查询属性
	      queryParam: {
	        deviceId: '',						// 设备ID
	        deviceNum: '',						// 设备码
	        obdErrorCode: '',					// 故障码
	        obdErrorDateBegin: '',				// 故障时间起
	        obdErrorDateEnd: '',					// 故障时间止
	        status: ''
	      }
	    }
	  },
	  beforeMount () {
	    Object.assign(this.vehicleInfo, this.$parent.vehicleInfo)
	    this.getTableInfo()
	    this.getUdc()
	  },
	  computed: {
			//	起止时间是否合法
	    validDates: function () {
	      if (this.queryParam.obdErrorDateBegin && this.queryParam.obdErrorDateEnd && this.queryParam.obdErrorDateBegin > this.queryParam.obdErrorDateEnd) {
	        return false
	      } else {
	        return true
	      }
	    }
	  },
	  methods: {
			// 查询方法
	    searchInfo () {
	      this.queryParam.page_index = 1
	      this.getTableInfo()
	    },
			// 获取OBD故障信息
	    getTableInfo () {
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/' + this.vehicleInfo.vehicleId + '/obd-error', {params: this.queryParam})
					.then((response) => {
	  if (response.body.success) {
	    const resInfo = response.body.data
	    const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
	    this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    }
	    this.infoList = resInfo.list
	  } else {
	    this.$parent.openModal(response.body.message)
	  }
	  this.loadingstatus = false
	}, (response) => {
	  this.$parent.openModal(response.body.message)
	  this.loadingstatus = false
	})
					.catch((response) => {
	  this.$parent.openModal(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    },
	    getUdc () {
	      let param = DICTIONARY_MAP.ALM_STATUS
	      this.$http.get(process.env.API_ROOT + '/system/udcs', {params: {udcTypes: param}})
				.then(res => {
	  if (res.data.success) {
					 	this.statuslist = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.ALM_STATUS)
	  } else {
	    this.$parent.openModal(res.data.message)
	  }
	}, res => {
	  this.$parent.openModal(res.data.message)
	}).catch(res => {
	  this.$parent.openModal(OPERATE_EXCEPTION)
	})
	    },
	    getPageNo (pageNo) { // 从分页组件获取页码参数
	      this.pageNo = pageNo
	      this.param.page_index = pageNo
	      this.getTableInfo()
	    },
	    resetQueryParams: function () {
	      this.$refs.dateFrom.handleClear()
	      this.$refs.dateTo.handleClear()
	      this.queryParam = {
	        deviceId: '',						// 设备ID
	        deviceNum: '',						// 设备码
	        obdErrorCode: '',				    // 故障码
	        obdErrorDateBegin: '',				// 故障时间起
	        obdErrorDateEnd: ''					// 故障时间止
	      }
	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// DetailObd.vue?40367674